import { GET } from 'shared/utils/ajax';

const media = `/rest/media`;
const searchType = media + `/searchType`;
export const getSearchType$ = () => GET(searchType);
